<!-- @format -->
<template>
    <div class="widget journey-template-publish-widget">
        <div class="widget-header">
            <h3>Publish to Partners</h3>
            <div class="svg-container widget-close-button" @click="closeWidget">
                <widget-close-svg />
            </div>
        </div>
        <div class="content-wrapper">
            <p>
                Please select which partners you would like this journey template to be published
                to:
            </p>
            <client-published-journey-template-table
                :journeyTemplateId="journeyTemplateId"
                @update:selectedItems="updateSelectedClients($event)"
            />
        </div>
        <div class="widget-footer">
            <div class="cancel-container">
                <app-button class="transparent-btn" @click="closeWidget">Cancel</app-button>
            </div>
            <div class="action-container">
                <app-button @click="save" :loading="isSaving">
                    {{ isSaving ? 'Saving' : 'Save' }}
                </app-button>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const ClientPublishedJourneyTemplateTable = () =>
    import('@/components/client/client-published-journey-template-table');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'journey-template-publish-widget',

    props: ['widget'],

    components: {
        'app-button': AppButton,
        'client-published-journey-template-table': ClientPublishedJourneyTemplateTable,
        'widget-close-svg': WidgetCloseSvg,
        'loading-screen-svg': LoadingScreenSvg,
    },

    data() {
        return {
            isInitializing: true,
            isSaving: false,
            journeyTemplateId: this.widget.journeyTemplateId,
            agencyId: null,
            selectedClients: [],
        };
    },

    methods: {
        updateSelectedClients(selectedClients) {
            this.selectedClients = selectedClients;
        },

        save() {
            this.isSaving = true;
            var clientIds = this.selectedClients.map((client) => {
                return client.id;
            });

            this.$api
                .post(`/api/JourneyTemplates/${this.journeyTemplateId}/Publish`, clientIds)
                .then(() => {
                    this.$helpers.showSuccessNotification(
                        'Your publish settings have been updated.'
                    );
                    this.isSaving = false;

                    EventBus.$emit('journey-template:update');
                    this.closeWidget();
                })
                .catch((error) => {
                    this.$helpers.showFailNotification(
                        'An error occurred while saving your publish settings.',
                        { error },
                    );
                    this.isSaving = false;
                });
        },

        getTemplate() {
            this.$api
                .get(`/service/JourneyTemplates/?$filter=Id eq ${this.journeyTemplateId}`)
                .then((response) => {
                    this.agencyId = response.data.value[0].AgencyId;
                    this.isInitializing = false;
                })
                .catch((response) => {
                    this.$helpers.showFailNotification(
                        'An error occurred while getting your template settings.',
                        { error },
                    );
                    this.isInitializing = false;
                });
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },
    },

    created() {
        this.getTemplate();
    },
};
</script>

<style>
.journey-template-publish-widget .saving-step {
    text-align: center;
}

.journey-template-publish-widget .content-wrapper {
    padding: 20px;
}

.journey-template-publish-widget .action-container {
    display: flex;
}

.journey-template-publish-widget .action-container .btn {
    margin-left: 15px;
}

.journey-template-publish-widget .cancel-container .btn.transparent-btn {
    background: transparent;
    color: #877d88;
}

.journey-template-publish-widget .cancel-container .btn.transparent-btn:hover {
    background: #e1e0e5;
}

.journey-template-publish-widget .action-container .btn.white-btn {
    background: #ffffff;
    color: #877d88;
    border: 2px solid #e9e9ef;
}
</style>
